import React, { useEffect, useRef } from "react";
import img1 from "../../Assets/HomePage/img1.png";
import img2 from "../../Assets/HomePage/img2.png";
import img3 from "../../Assets/HomePage/img3.png";
import img4 from "../../Assets/HomePage/img4.png";
import img5 from "../../Assets/HomePage/img5.png";
import img6 from "../../Assets/HomePage/img6.png";
import img7 from "../../Assets/HomePage/img7.png";
import img8 from "../../Assets/HomePage/img8.png";
import img9 from "../../Assets/HomePage/img9.png";
import img10 from "../../Assets/HomePage/img10.png";
import img11 from "../../Assets/HomePage/img11.png";
import img12 from "../../Assets/HomePage/img12.png";
import img13 from "../../Assets/HomePage/img13.png";
import img14 from "../../Assets/HomePage/img14.png";
import img15 from "../../Assets/HomePage/img15.png";
import img16 from "../../Assets/HomePage/img16.png";
import img17 from "../../Assets/HomePage/img17.png";
import img18 from "../../Assets/HomePage/img18.png";
import img19 from "../../Assets/HomePage/img19.png";
import img20 from "../../Assets/HomePage/img20.png";

const images = [
  { id: 1, src: img19, alt: "Company Logo 19" },
  { id: 1, src: img17, alt: "Company Logo 17" },
  { id: 1, src: img1, alt: "Company Logo 1" },
  { id: 1, src: img2, alt: "Company Logo 2" },
  // { id: 1, src: img3, alt: "Company Logo 3" },
  { id: 1, src: img3, alt: "Company Logo 3" },
  { id: 1, src: img4, alt: "Company Logo 4" },
  { id: 1, src: img5, alt: "Company Logo 5" },
  { id: 1, src: img6, alt: "Company Logo 6" },
  { id: 1, src: img7, alt: "Company Logo 7" },
  // { id: 1, src: img20, alt: "Company Logo 20" },
  { id: 1, src: img20, alt: "Company Logo 20" },
  { id: 1, src: img8, alt: "Company Logo 8" },
  { id: 1, src: img9, alt: "Company Logo 9" },
  { id: 1, src: img10, alt: "Company Logo 10" },
  { id: 1, src: img11, alt: "Company Logo 11" },
  { id: 1, src: img12, alt: "Company Logo 12" },
  // { id: 1, src: img12, alt: "Company Logo 12" },
  { id: 1, src: img13, alt: "Company Logo 13" },
  { id: 1, src: img14, alt: "Company Logo 14" },
  { id: 1, src: img15, alt: "Company Logo 15" },
  { id: 1, src: img18, alt: "Company Logo 18" },
  // { id: 1, src: img16, alt: "Company Logo 16" },
  { id: 1, src: img16, alt: "Company Logo 16" },
];

const LogoContainer = () => {
  return (
    <div className="w-full p-4 md:p-8 overflow-hidden relative mt-4 md:mt-0">
      <div className="grid grid-flow-col auto-cols-max gap-4 md:gap-6 animate-scroll">
        {[...images, ...images].map((logo, index) => (
          <div
            key={`${logo.id}-${index}`}
            className="col-span-1 flex items-center justify-center p-2 md:p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100"
            style={{ width: "150px", height: "100px" }}
          >
            <img
              src={logo.src}
              alt={logo.alt}
              className="w-full h-auto max-h-14 md:max-h-20 object-contain"
              loading="lazy"
            />
          </div>
        ))}
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          display: grid;
          animation: scroll 30s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default LogoContainer;
